export default class UpdateIMUserModel {
  code?: string;

  gender?: string;

  name?: string;

  phonePrefix='86';// 默认是CN

  phoneNo?: string;

  remark?: string;

  status?: number;

  creationDate?: Date;
}
